import React from "react";
import { ColumnDef } from "@tanstack/react-table";
import {DcddUserProps, RegisteredDcddUserProps } from "../../state/actionType";
import ActionButton from "../ActionButton";

export const TableColumns: ColumnDef<DcddUserProps>[] = [
  // {
  //   id: "slNo",
  //   header: "Sl. No",
  //   cell: ({ row }) => row.index + 1,
  // },
  {
    accessorFn: (row) => row?.user_profile?.name,
    id: "name",
    header: "Name",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row?.category,
    id: "category",
    header: "Category",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row?.email,
    id: "email",
    header: "Email",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row?.id,
    id: "user_id",
    header: "User ID",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row?.login_id,
    id: "login_id",
    header: "Login ID",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row?.mobile_no,
    id: "mobile_no",
    header: "Mobile No.",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row?.password,
    id: "password",
    header: "Password",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row?.status,
    id: "status",
    header: "Status",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row?.student_id,
    id: "student_id_user",
    header: "Student ID (User)",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row?.user_identifier,
    id: "user_identifier",
    header: "User Identifier",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row?.user_profile?.cid,
    id: "cid",
    header: "CID",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row?.user_profile?.dob,
    id: "dob",
    header: "Date of Birth",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row?.user_profile?.dzongkhag?.name,
    id: "dzongkhag",
    header: "Dzongkhag",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row?.user_profile?.school?.name,
    id: "school",
    header: "School",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row?.user_profile?.grade?.name,
    id: "grade",
    header: "Grade",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row?.user_profile?.eccd?.name,
    id: "eccd_id",
    header: "ECCD ID",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row?.user_profile?.gender,
    id: "gender",
    header: "Gender",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row?.user_profile?.id,
    id: "user_profile_id",
    header: "Profile ID",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row?.user_profile?.profile_picture,
    id: "user_profile_picture",
    header: "Profile Picture",
    cell: (info) => (
      <img
        src={info.getValue() as string}
        alt="Profile"
        className="w-10 h-10 rounded-full object-cover"
      />
    ),
  },
  {
    accessorFn: (row) => row?.user_profile?.student_id,
    id: "student_id_user_profile",
    header: "Student ID (Profile)",
    cell: (info) => info.getValue(), 
  },
  {
    id: "action",
    header: "Actions",
    cell: ({ row }) => (
      <div className="flex justify-center items-center gap-2">
        <ActionButton items={row?.original} />
      </div>
    ),
    enableSorting: false,
  },
];
